<script setup lang="js">
import ModalTemplateSide from '@/components/modals/ModalTemplateSide.vue';
import useModal from '@/stores/modal.store';
import { useInputGeometriesStore } from '@/stores/inputGeometries.store';
import { useProjectStore } from '@/stores/project.store';
import { storeToRefs } from 'pinia';
import { onMounted, ref, defineProps, computed, watch } from 'vue';
import { useRouteParams } from '@vueuse/router';
import { useValidationRuleStore } from '@/stores/validationRule.store';
import Multiselect from 'vue-multiselect';

const { closeModal } = useModal();
const inputGeometriesStore = useInputGeometriesStore();
const { inputGeometryEditRequest } = storeToRefs(inputGeometriesStore);
const projectStore = useProjectStore();
const { project } = storeToRefs(projectStore);
const validationRuleStore = useValidationRuleStore();
const { rules } = storeToRefs(validationRuleStore);
const bpId = useRouteParams('bpId');
const nodeId = useRouteParams('nodeId');
const projectId = useRouteParams('projectId');
const types = [
  { id: null, text: '' },
  { id: 'Polygon', value: 'Полигон' },
  { id: 'LineString', value: 'Линия' },
  { id: 'Point', value: 'Точка' }
];
const title = ref({});
const type = ref('');
const settings = ref(null);
const props = defineProps({
  selectedGeom: Object
});
const validationRules = ref([]);

const formFieldType = {
  LineString: validationRuleStore.GEO_LINE,
  Point: validationRuleStore.GEO_POINT,
  Polygon: validationRuleStore.GEO_POLYGON,

};

const availableValidationRules = computed(() => {
  if (!type.value) {
    return [];
  }

  return rules.value.filter((r) => r.form_type === formFieldType[type.value]);
});
watch(type, () => {
  validationRules.value = validationRules.value.filter(
    (r) => r.form_type === formFieldType[type.value]
  );
});
onMounted(() => {
  inputGeometriesStore.clearRequestVariables();
  if (!project.value.locales) {
    projectStore.getProject(projectId.value);
  }
  if (props.selectedGeom) {
    title.value = props.selectedGeom.geometry.title;
    // Тип живёт на привязке, а не на наборе свойств, и неизменяем.
    type.value = props.selectedGeom.type;
     if (props.selectedGeom.geometry.settings?.validationRules) {
      validationRules.value = props.selectedGeom.geometry.settings?.validationRules;
    }
  }
});

function updateGeometry() {
  settings.value = {};

   if (validationRules.value.length) {
    settings.value.validationRules = validationRules.value;
  }
  inputGeometriesStore
    .inputGeomUpdate(
      projectId.value,
      bpId.value,
      nodeId.value,
      props.selectedGeom.id,
      props.selectedGeom.geometry.title,
      type.value,
      settings.value
    )
    .then(() => {
      closeModal();
    });
}
function isErrorField(fieldName) {
  if (inputGeometryEditRequest.value.error?.errors) {
    return inputGeometryEditRequest.value.error.errors[fieldName] || false;
  }
}
function isNotFieldError() {
  if (!inputGeometryEditRequest.value.error?.errors) {
    return inputGeometryEditRequest.value.error;
  }
}
</script>

<template>
  <ModalTemplateSide @submit="updateGeometry" :disableButtons="inputGeometryEditRequest.isLoading">
    <template v-slot:title>Редактирование геометрии для заполнения</template>
    <template v-slot:body>
      <div class="mt-3" v-for="locale in project.locales" :key="locale.id">
        <label class="form-label">Наименование геометрии на {{ locale.name }}</label>
        <input
          type="text"
          v-model="title[locale.id]"
          class="form-control"
          :class="{ error: isErrorField('title') }"
        />
      </div>
      <p v-if="isErrorField('title')" class="error-mesage">
        <span v-for="error in isErrorField('title')">{{ error }}</span>
      </p>
      <div class="mt-3">
        <label class="form-label">Тип</label>
        <select
          v-model="type"
          class="form-select"
          disabled
          title="Тип нельзя изменить после создания геометрии"
        >
          <option v-for="t in types" :key="t.id" :value="t.id">
            {{ t.value }}
          </option>
        </select>
      </div>
      <div class="mt-3" v-if="type">
        <label class="form-label">Кастомные валидации</label>
        <Multiselect
          v-model="validationRules"
          :options="availableValidationRules"
          placeholder="Выбрать..."
          :multiple="true"
          label="name"
          track-by="name"
          class="multiselect-style"
        />
      </div>
      <p v-if="isNotFieldError()" class="error-mesage">
        {{ isNotFieldError() }}
      </p>
    </template>
    <template v-slot:submit>Сохранить</template>
  </ModalTemplateSide>
</template>
